import {all} from 'redux-saga/effects';
import authSagas from './Auth';
import usersSagas from './Users';
import doctorsSagas from './Doctors';
import hospitalsSagas from './Hospitals';
import notificationSagas from './Notifications';
import blogsSagas from './Blogs';
import appointmentsSagas from "./Appointments";
import appointmentdashSagas from "./Appointmentdash";
import companyinfoSagas from "./Companyinfo";
import paymentsSagas from "./Payments";
import payoutsSagas from "./Payouts";
import htmlcontentSagas from "./Htmlcontent";
import illnessSagas from "./Illness";
import faqSagas from "./Faq";
import adminSagas from "./Admin";

export default function* rootSaga(getState) {
    yield all([
        authSagas(),
        usersSagas(),
        doctorsSagas(),
        blogsSagas(),
        notificationSagas(),
        hospitalsSagas(),
        paymentsSagas(),
		payoutsSagas(),
        appointmentsSagas(),
		appointmentdashSagas(),
		companyinfoSagas(),
        illnessSagas(),
		htmlcontentSagas(),
		faqSagas(),
		adminSagas(),
    ]);
}
